<!-- eslint-disable vue/no-mutating-props -->
<template>
  <el-dialog
    v-model="show"
    width="600"
    :fullscreen="$vuetify.display.width <= 600 ? true : false"
    class="public-style"
    destroy-on-close
    align-center
    @close="close"
  >
    <el-form
      ref="ruleFormRef"
      :rules="rules"
      :model="battery_intensities_data"
      :style="[$vuetify.display.width < 600 ? 'height: 550;' : '']"
      :label-position="`top`"
    >
      <el-space fill style="width: 100%">
        <el-alert type="info" class="alert-style" show-icon :closable="false">
          <p class="ma-0 text-white">Battery Intensities :</p>
        </el-alert>
        <el-row :gutter="20">
          <el-col :span="$vuetify.display.width >= 500 ? 12 : 24">
            <el-form-item
              class="label-style"
              prop="monitoring_period_id"
              label="Monitoring Period: "
            >
              <!-- <el-input v-model="baseline_data.charger_type" /> -->
              <el-select
                v-model="battery_intensities_data.monitoring_period_id"
                placeholder="Select"
                class="w-100"
              >
                <el-option
                  v-for="item in monitoringPeriods"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                  <span style="float: left">{{ item.name }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="$vuetify.display.width >= 500 ? 12 : 24">
            <el-form-item
              class="label-style"
              prop="customer_id"
              label="Customer: "
            >
              <el-select
                v-model="battery_intensities_data.customer_id"
                @change="handleCustomerSelect"
                placeholder="Select"
                filterable
                class="w-100"
              >
                <el-option
                  v-for="item in customers"
                  :key="item.id"
                  :label="item.full_name"
                  :value="item.id"
                >
                  <span style="float: left">{{ item.full_name }}</span>
                  <!-- <span style="text-align: center">{{ item.country }}</span> -->
                  <span
                    style="
                      float: right;
                      color: var(--el-text-color-secondary);
                      font-size: 13px;
                    "
                  >
                    {{ item.phone }}
                  </span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="$vuetify.display.width >= 500 ? 12 : 24">
            <el-form-item
              class="label-style"
              prop="charging_site_id"
              label="Charging Site: "
            >
              <!-- <el-input v-model="user_data.customer_id" /> -->
              <el-select
                v-model="battery_intensities_data.charging_site_id"
                placeholder="Select"
                filterable
                class="w-100"
              >
                <el-option
                  v-for="item in charging_sites"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id"
                >
                  <span style="float: left">{{ item.title }}</span>
                  <span
                    style="
                      float: right;
                      color: var(--el-text-color-secondary);
                      font-size: 13px;
                    "
                  >
                    {{ item.city }}
                  </span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="$vuetify.display.width >= 500 ? 24 : 24">
            <el-form-item
              class="label-style"
              prop="emission_intensity"
              label="Emission Intensity: "
            >
              <el-input v-model="battery_intensities_data.emission_intensity" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-space>
    </el-form>
    <!-- </el-row> -->
    <template #footer>
      <span class="dialog-footer">
        <el-button
          size="medium"
          class="me-primary-light"
          @click.stop="pasteData"
          :disabled="copiedData == null"
          color="#234B49"
        >
          <i class="fa fa-paste me-2 me-primary-light"></i><span class="moderat-btn-apply-light">Paste</span>
        </el-button>

        <el-button
          size="medium"
          class="me-primary-light"
          @click.stop="confirm"
          color="#234B49"
        >
          <i class="fa fa-check me-2 me-primary-light"></i><span class="moderat-btn-apply-light">Confirm</span>
        </el-button>
        <el-button
          size="medium"
          class="me-primary"
          @click.stop="close"
          color="#ddf0ac"
        >
          <i class="fa fa-times me-2 me-primary"></i><span class="moderat-btn-apply">Cancel</span>
        </el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
// import "animate.css";
import UserService from "../../services/user.service";
// import moment from "moment";
export default {
  props: {
    open_modal: {
      type: Boolean,
      default: false,
    },
    copiedDataProp: {
      type: Object,
      default() {
        return null;
      },
    },
    data_modal: {
      type: Object,
      // eslint-disable-next-line no-unused-vars
      default(rawProps) {
        return rawProps;
      },
    },
    monitoringPeriodsProp: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      show: this.open_modal,
      rules: {
        monitoring_period_id: {
          required: true,
          message: "Please select a monitoring period.",
          trigger: "blur",
        },
        customer_id: [
          {
            required: true,
            message: "Please select a customer.",
            trigger: "change",
          },
        ],
        charging_site_id: [
          {
            required: true,
            message: "Please select a charging site.",
            trigger: "change",
          },
        ],
      },
      battery_intensities_data: {
        id: 0,
        monitoring_period_id: null,
        customer_id: null,
        customer_name: null,
        charging_site_id: null,
        emission_intensity: 0,
      },

      monitoringPeriods: [],
      charging_sites: [],
      customers: [],
      copiedData: null,
    };
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    monitoringPeriodsProp: {
      handler: function (newValue) {
        this.monitoringPeriods = newValue;
      },
      deep: true,
    },
    copiedDataProp: {
      handler: function (newValue) {
        this.copiedData = newValue;
      },
      deep: true,
    },
    // eslint-disable-next-line no-unused-vars
    open_modal: function (newVal, oldVal) {
      this.show = newVal;
      if (newVal == true) {
        this.battery_intensities_data = JSON.parse(this.data_modal);
        this.fetchCustomerData();
        if (
          this.battery_intensities_data.customer_id != null &&
          this.battery_intensities_data.customer_id != 0
        ) {
          this.fetchChargingSiteData();
        }
        // this.fetchChargingSiteData();
      }
    },
  },
  methods: {
    async fetchCustomerData() {
      await UserService.getCustomers(null)
        .then(
          (response) => {
            this.customers = response.data.customers;
          },
          (error) => {
            this.loading = false;
            console.log(error);
            if (error.response.status == 401) {
              this.$router.push({
                path: "/",
              });
            }
          }
        )
        .catch((error) => {
          this.loading = false;
          console.log(error);
          if (error.response.status == 401) {
            this.$router.push({
              path: "/",
            });
          }
        })
        .finally(() => (this.loading = false));
    },
    pasteData() {
      this.battery_intensities_data = {
        id: 0,
        monitoring_period_id: this.copiedData.monitoring_period_id,
        customer_id: this.copiedData.customer_id,
        charging_site_id: this.copiedData.charging_site_id,
        emission_intensity: this.copiedData.emission_intensity,
      }
    },
    handleCustomerSelect(item) {
      // console.log(item);
      this.battery_intensities_data.customer_id = item;
      this.battery_intensities_data.charging_sites_id = null;
      this.fetchChargingSiteData();
    },
    async fetchChargingSiteData() {
      let body = {
        customer_id: this.battery_intensities_data.customer_id,
      };
      // bypassing the pagination for fetching charging sites according to selected customer
      // modify page size to 0 to active pagination
      await UserService.getChargingSites(body, "", 1, 0)
        .then(
          (response) => {
            this.charging_sites = response.data.charging_sites;
          },
          (error) => {
            this.loading = false;
            console.log(error);
            if (error.response.status == 401) {
              this.$router.push({
                path: "/",
              });
            }
          }
        )
        .catch((error) => {
          this.loading = false;
          console.log(error);
          if (error.response.status == 401) {
            this.$router.push({
              path: "/",
            });
          }
        })
        .finally(() => (this.loading = false));
    },
    isValidDate(dateString) {
      const dateRegex = /^(\d{4})-(\d{2})-(\d{2})$/;
      if (dateRegex.test(dateString)) {
        const date = new Date(dateString);
        if (!isNaN(date.getTime())) {
          return true;
        } else {
          return false;
        }
      } else return false;
    },
    isNewUser() {
      if (this.battery_intensities_data.id == 0) return true;
      else return false;
    },
    close() {
      this.show = false;
      this.$emit("close_modal", false);
    },
    async confirm() {
      await this.$refs["ruleFormRef"].validate((valid, fields) => {
        if (valid) {
          UserService.SetBatteryIntensities(this.battery_intensities_data)
            .then(
              (response) => {
                this.$emit("confirm_modal", response.data.battery_intensity);
                this.$emit("refreshDataTable");
              },
              (error) => {
                this.loading = false;
                console.log(error);
                if (error.response.status == 401) {
                  this.$router.push({
                    path: "/",
                  });
                }
              }
            )
            .catch((error) => {
              this.loading = false;
              console.log(error);
              if (error.response.status == 401) {
                this.$router.push({
                  path: "/",
                });
              }
            })
            .finally(() => (this.loading = false));
        } else {
          console.log("error submit!", fields);
        }
      });
    },
    isNumeric: function (n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    },
  },
};
</script>

<style>
.el-dialog__body {
  padding: 30px 10px;
}
.el-input__inner {
  padding: 0 10px !important;
}

::-webkit-scrollbar {
  width: 8px;
}
/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.el-form-item__label {
  margin-bottom: 0 !important;
}
.el-form-item__content > .el-checkbox {
  margin-top: 16px;
  margin-bottom: 0;
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>
